export const toMovieList = () => "/movies";
export const toPeopleList = () => "/people";
export const toMovieDetails = () => "/movies/:id";
export const toPeopleDetails = () => "/people/:id";
